import React from 'react';

export default function ProgressIcon({ status }: { status: string }) {
  const d = status === 'completed' ? 'm6 12 4 4 8-8' : status === 'failed' ? 'm8 8 8 8M8 16l8-8' : status === 'processing' ? 'M12 6v6l4 2' : 'M8 12h8';
  return <svg className="wp-progressIcon" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d={d}/></svg>;
}
